import React from 'react';
import { chatNewMessagesStr } from '../../chat/modules/common';

export class Badge extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { count } = this.props;
    if (count && count > 0) {
      return <div className="chat-popup_notification">{chatNewMessagesStr(count)}</div>;
    } else {
      return null;
    }
  }
}

export default Badge;



// WEBPACK FOOTER //
// ./app/javascript/customer_chat/components/Badge.js